import React, { useEffect, useState, useRef } from 'react';
import {
  Box,
  IconButton,
  BottomNavigation,
  BottomNavigationAction,
  Typography,
  Slider,
  Button,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import FavoriteIcon from '@mui/icons-material/Favorite';
import VisibilityIcon from '@mui/icons-material/Visibility';
import HomeIcon from '@mui/icons-material/Home';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import SettingsIcon from '@mui/icons-material/Settings';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
const videos = [
  { id: 1, url: '/1.mp4', views: 12345, baslik: 'Başlık 1 Video',desc:"Bu bir deneme yazısıdır ve demenemek için burdadır,lütfen deneme yazısını dikkate almayın yakında deneme yazısı burda omayacak." },
  { id: 2, url: '/2.mp4', views: 67890, baslik: 'Başlık 2 Video',desc:"Bu bir deneme yazısıdır ve demenemek için burdadır,lütfen deneme yazısını dikkate almayın yakında deneme yazısı burda omayacak." },
];

function Header({ toggleMuted, muted, handleFullscreen, activettext }) {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: 70,
        backgroundColor: 'rgb(228 9 127 / 84%)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        px: 2,
        zIndex: 1000,
      }}
    >
      <img src="/logo.png" alt="logo" style={{ width: '200px' }} />
      <Box sx={{ display: 'flex', gap: 1 }}>
        <IconButton onClick={toggleMuted} sx={{ color: '#fff' }}>
          {muted ? <VolumeOffIcon /> : <VolumeUpIcon />}
        </IconButton>
        <IconButton onClick={()=>handleFullscreen()} sx={{ color: '#fff' }}>
          <FullscreenIcon />
        </IconButton>
      </Box>
    </Box>
  );
}

function VideoCard({ video, onActive, globalMuted }) {
  const [liked, setLiked] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const videoRef = useRef(null);

  // Slider için state'ler: mevcut zaman ve toplam süre
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  // Video zaman güncellemesi ve meta veriler yüklendiğinde süre ayarlama
  useEffect(() => {
    const videoEl = videoRef.current;
    if (!videoEl) return;
    const handleTimeUpdate = () => {
      setCurrentTime(videoEl.currentTime);
    };
    const handleLoadedMetadata = () => {
      setDuration(videoEl.duration);
    };
    videoEl.addEventListener('timeupdate', handleTimeUpdate);
    videoEl.addEventListener('loadedmetadata', handleLoadedMetadata);
    return () => {
      videoEl.removeEventListener('timeupdate', handleTimeUpdate);
      videoEl.removeEventListener('loadedmetadata', handleLoadedMetadata);
    };
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && videoRef.current) {
            onActive(videoRef.current, video.baslik);
            videoRef.current.play().catch(() => {});
            setIsPaused(false);
          } else if (videoRef.current) {
            videoRef.current.pause();
            setIsPaused(true);
          }
        });
      },
      { threshold: 0.6 }
    );

    if (videoRef.current) observer.observe(videoRef.current);
    return () => {
      if (videoRef.current) observer.unobserve(videoRef.current);
    };
  }, [onActive, video.baslik]);

  const handleVideoClick = () => {
    if (videoRef.current) {
      if (videoRef.current.paused) {
        videoRef.current.play();
        setIsPaused(false);
      } else {
        videoRef.current.pause();
        setIsPaused(true);
      }
    }
  };

  const handleSliderChange = (event, newValue) => {
    if (videoRef.current) {
      videoRef.current.currentTime = newValue;
    }
    setCurrentTime(newValue);
  };

  // Zaman bilgisini dakika: saniye formatında oluşturma
  const formatTime = (time) =>
    new Date(time * 1000).toISOString().substr(14, 5);

  return (
    <Box sx={{ position: 'relative', height: '100vh', scrollSnapAlign: 'start' }}>
<video
  ref={videoRef}
  src={video.url}
  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
  loop
  muted={globalMuted}
  autoPlay
  playsInline  // Bu özelliği ekledik.
  onClick={handleVideoClick}
/>


      {isPaused && (
        <Box
          onClick={handleVideoClick}
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 2,
          }}
        >
          <IconButton
            sx={{
              backgroundColor: 'rgba(0,0,0,0.5)',
              color: '#fff',
              width: 80,
              height: 80,
              borderRadius: '50%',
            }}
          >
            <PlayArrowIcon sx={{ fontSize: 50 }} />
          </IconButton>
        </Box>
      )}

      <Box
        sx={{
          position: 'absolute',
          right: 16,
          bottom: "30vh",
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
        }}
      >
        <IconButton sx={{ backgroundColor: 'rgba(0,0,0,0.5)', color: '#fff' }}>
          <InfoIcon />
        </IconButton>
        <IconButton sx={{ backgroundColor: 'rgba(0,0,0,0.5)', color: '#fff' }}>
          <OpenInNewIcon />
        </IconButton>
        <Box
          sx={{
            textAlign: 'center',
            color: '#fff',
            fontSize: '0.875rem',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 0.1,
          }}
        >
        <IconButton
          onClick={() => setLiked(!liked)}
          sx={{ backgroundColor: 'rgba(0,0,0,0.5)', color: liked ? 'pink' : '#fff' }}
        >
          <FavoriteIcon />
          
        </IconButton>
        <Typography sx={{fontSize:"0.6rem"}}> {video.views}</Typography>
        </Box>
        <Box
          sx={{
            textAlign: 'center',
            color: '#fff',
            fontSize: '0.875rem',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 0.1,
          }}
        >
          <IconButton sx={{ backgroundColor: 'rgba(0,0,0,0.5)', color: '#fff' }}>
            <VisibilityIcon />
          </IconButton>
          <Typography sx={{fontSize:"0.6rem"}}> {video.views}</Typography>
        </Box>
      </Box>

      <Box         sx={{
          position: 'absolute',
          bottom: "28vh",
          left: 0,
          right: 0,
          px: 2,
          zIndex: 2,
          color:"#fff",
          width:"85%",
        }}>
        <Typography sx={{fontWeight:"600",fontSize:"1rem"}}>{video.baslik}</Typography>
        <Typography sx={{fontSize:"0.6rem"}}>{video.desc}</Typography>
      </Box>
      <Box
        sx={{
          position: 'absolute',
          bottom: "17vh",
          left: 0,
          right: 0,
          px: 2,
          zIndex: 2,
          color:"#fff",
          backgroundColor:"#00000063"
        }}
      >
         <IconButton aria-label="delete" sx={{color:"#fff",padding:0,marginBottom:"10px",marginTop:"10px"}}>
              <OpenInNewIcon style={{width:"30px",marginLeft:"-6px"}}/>
              <Typography >{"1. Bölüm Fragman"}</Typography>
        </IconButton>
        <Box sx={{ position: 'relative' }}>
          {/* Dakika bilgilerini slider'ın üstüne mutlak konumlandırdık */}
          <Box
            sx={{
              position: 'absolute',
              top: -4,
              left: 0,
              right: 0,
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Typography variant="caption" sx={{ color: '#fff' }}>
              {formatTime(currentTime)}
            </Typography>
            <Typography variant="caption" sx={{ color: '#fff' }}>
              {formatTime(duration)}
            </Typography>
          </Box>
          <Slider
            value={currentTime}
            min={0}
            max={duration}
            onChange={handleSliderChange}
            sx={{
              height: 4,
              color: '#fff',
              borderRadius: 2,
              '& .MuiSlider-track': {
                border: 'none',
                borderRadius: 2,
              },
              '& .MuiSlider-thumb': {
                width: 12,
                height: 12,
                padding:0,
                backgroundColor: '#fff',
                border: '2px solid #fff',
                '&:hover, &.Mui-focusVisible, &.Mui-active': {
                  boxShadow: '0 0 0 8px rgba(255, 255, 255, 0.16)',
                },
              },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}

function App() {
  const [activeVideo, setActiveVideo] = useState(null);
  const [muted, setMuted] = useState(true);
  const [activettext, setActiveText] = useState('');

  const toggleMuted = () => {
    if (activeVideo) {
      activeVideo.muted = !activeVideo.muted;
      setMuted(activeVideo.muted);
    }
  };

  const handleFullscreen = () => {
    if (activeVideo) {
      if (activeVideo.requestFullscreen) {
        activeVideo.requestFullscreen();
      } else if (activeVideo.webkitRequestFullscreen) {
        activeVideo.webkitRequestFullscreen();
      } else if (activeVideo.msRequestFullscreen) {
        activeVideo.msRequestFullscreen();
      } else if (navigator.userAgent.match(/iPhone|iPad|iPod/)) {
        // iOS Safari için tam ekran kontrolü
        activeVideo.webkitEnterFullScreen(); // Safari iOS'ta tam ekran için bu metod kullanılır
      }
    }
  };
  

  return (
    <Box sx={{ height: '100vh', width: '100%', position: 'relative', backgroundColor: '#000',paddingBottom:"50px"}}>
      <Header
        toggleMuted={toggleMuted}
        muted={muted}
        handleFullscreen={handleFullscreen}
        activettext={activettext}
      />

      <Box sx={{ height: '100%', overflowY: 'scroll', scrollSnapType: 'y mandatory' }}>
        {videos.map((video,index) => (
          <VideoCard
            key={video.id}
            video={video}
            onActive={(videoRef, title) => {
              setActiveVideo(videoRef);
              setActiveText(video);
            }}
            globalMuted={muted}
          />
        ))}
      </Box>

      <BottomNavigation
  showLabels
  sx={{
    position: 'fixed',
    bottom: 0,
    width: '100%',
    color: "#fff",
    backgroundColor: 'rgb(194 12 113 / 78%)',
    zIndex: 1000,
    paddingBottom: 'env(safe-area-inset-bottom)', // iOS için safe area desteği
    "& .MuiBottomNavigationAction-label": {
      color: "#fff",
    },
  }}
>
  {/* ... navigation actions ... */}


        <BottomNavigationAction label="Home" icon={<HomeIcon sx={{ color: '#fff' }} />} />
        <BottomNavigationAction label="Keşfet" icon={<VideoLibraryIcon sx={{ color: '#fff' }} />} />
        <BottomNavigationAction label="Ayarlar" icon={<SettingsIcon sx={{ color: '#fff' }} />} />
        </BottomNavigation>
    </Box>
  );
}

export default App;
